import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import Tip from './Tip';
import TipDivider from './TipDivider';
import TipButton from './TipButton';
import s from './SubscriptionTips.scss';

export interface Props {
  moduleId: number;
  className?: string;
}

const SubscriptionTips: React.FC<Props> = ({ className }) => {
  const { t } = useTranslation();
  // TODO: Replace readMoreHref with knowledge base article links
  return (
    <div className={c(s['root'], className)}>
      <Tip
        heading={t('widgets.subscriptionsSection.tips.top.heading')}
        text={t('widgets.subscriptionsSection.tips.top.text')}
        button={
          <TipButton
            tipType="top"
            href={t('widgets.subscriptionsSection.tips.top.url')}
            biData={{
              evid: BiEventType.DEFAULT,
              click_info: 'tier_knowledge_base',
            }}
          >
            {t('widgets.subscriptionsSection.tips.top.buttonText')}
          </TipButton>
        }
      />
      <TipDivider className={s['divider']} />
      <Tip
        heading={t('widgets.subscriptionsSection.tips.bottom.heading')}
        text={t('widgets.subscriptionsSection.tips.bottom.text')}
        button={
          <TipButton
            tipType="bottom"
            href={t('widgets.subscriptionsSection.tips.bottom.url')}
            biData={{
              evid: BiEventType.DEFAULT,
              click_info: 'send_feedback',
            }}
          >
            {t('widgets.subscriptionsSection.tips.bottom.buttonText')}
          </TipButton>
        }
      />
    </div>
  );
};
SubscriptionTips.displayName = 'SubscriptionTips';

export default SubscriptionTips;
